import { fetchFile } from '@ffmpeg/util';

export const extractAudio = async (ffmpeg, videoFile, format) => {
  await ffmpeg.writeFile('input_video', await fetchFile(videoFile));
  const outputName = `extracted_audio.${format}`;
  const acodec = format === 'mp3' ? 'libmp3lame' : 'pcm_s16le';
  
  await ffmpeg.exec(['-i', 'input_video', '-vn', '-acodec', acodec, '-ar', '44100', '-ac', '2', outputName]);
  const data = await ffmpeg.readFile(outputName);
  return new Blob([data.buffer], { type: `audio/${format}` });
};

export const mergeAudioVideoFiles = async (ffmpeg, videoFile, audioFile) => {
  await ffmpeg.writeFile('input_video', await fetchFile(videoFile));
  await ffmpeg.writeFile('input_audio', await fetchFile(audioFile));

  await ffmpeg.exec([
    '-i', 'input_video', '-i', 'input_audio', '-map', '0:v:0', '-map', '1:a:0',
    '-c:v', 'copy', '-c:a', 'aac', '-shortest', 'merged_output.mp4'
  ]);

  const data = await ffmpeg.readFile('merged_output.mp4');
  return new Blob([data.buffer], { type: 'video/mp4' });
};

// Nan videoService.js
export const overlayCommentOnVideo = async (ffmpeg, videoFile, commentImageBlob) => {
  await ffmpeg.writeFile('input_video', await fetchFile(videoFile));
  await ffmpeg.writeFile('comment_image.png', await fetchFile(commentImageBlob));

  const filter = [
    '[0:v]scale=1080:1920:force_original_aspect_ratio=increase,crop=1080:1920,boxblur=20:10[bg];',
    '[0:v]scale=1080:1920:force_original_aspect_ratio=decrease[fg];',
    '[bg][fg]overlay=(W-w)/2:(H-h)/2[base];',
    '[base][1:v]overlay=x=0:y=0' 
  ].join('');

  await ffmpeg.exec([
    '-i', 'input_video',
    '-i', 'comment_image.png',
    '-filter_complex', filter,
    '-c:a', 'copy',
    '-preset', 'ultrafast',
    'output_commented.mp4'
  ]);

  const data = await ffmpeg.readFile('output_commented.mp4');
  return new Blob([data.buffer], { type: 'video/mp4' });
};


export const convertWebmToMp4 = async (ffmpeg, webmBlob) => {
  await ffmpeg.writeFile('input.webm', await fetchFile(webmBlob));
  await ffmpeg.exec(['-i', 'input.webm', '-c:v', 'libx264', '-preset', 'ultrafast', '-c:a', 'aac', 'output.mp4']);
  const data = await ffmpeg.readFile('output.mp4');
  return new Blob([data.buffer], { type: 'video/mp4' });
};